export enum InventoryType {
  /**
   * @deprecated use PACKAGE
   */
  TABLE = 'TABLE',
  PACKAGE = 'PACKAGE',
  TICKET = 'TICKET',
  COVER = 'COVER',
}

export enum InventoryTypeName {
  TICKET = 'Ticket',
  TABLE = 'Table',
  PACKAGE = 'Table',
  COVER = 'Cover',
}

export enum InventoryEvent {
  GENERATE_RECURRING = 'TL_ACTIVE_INVENTORY_GENERATE_RECURRING',
  SOLD_OUT = 'TL_ACTIVE_INVENTORY_SOLD_OUT',
  UPDATE_RECURRING = 'TL_ACTIVE_INVENTORY_UPDATE_RECURRING',
  CLIENT_REFRESH_REQUESTED = 'TL_ACTIVE_INVENTORY_CLIENT_REFRESH_REQUESTED',
}

export enum InventoryPubSubReason {
  CREATED = 'inventory_created',
  UPDATED = 'inventory_updated',
  DELETED = 'inventory_deleted',
}

export const inventoryManageRefreshPubSubReasons = [
  InventoryPubSubReason.CREATED,
  InventoryPubSubReason.UPDATED,
  InventoryPubSubReason.DELETED,
] as const

export enum InventoryErrorMessage {
  SYNC_QUANTITY_BY_SECTION_CONFLICT = 'Sorry, this section is already assigned to another inventory.',
}

export enum InventorySort {
  NAME_ASC = 'name',
  NAME_DSC = '-name',
  PRICE_ASC = 'price',
  PRICE_DSC = '-price',
  DATE_ASC = 'date',
  DATE_DSC = '-date',
}

export enum InventoryTierMode {
  QUANTITY = 'QUANTITY',
  GUEST_COUNT = 'GUEST_COUNT',
}

export const inventoryTimes = {
  MIN_START_TIME: 360, //Earliest a table can be listed - 6:00 AM
  MAX_END_TIME: 1799, //5:59 AM (next day) = 1799 = 1440 (min in 24 hours) + 359 (5 hour 59 min)
  DEFAULT_START_TIME: 1290, // 9:30 PM
  DEFAULT_END_TIME: 1410, // 11:30 PM
  DEFAULT_SELLING_END: new Date('1970-01-02T00:30:00.000Z'),
  DEFAULT_ARRIVAL_START: new Date('1970-01-01T21:00:00.000Z'),
  DEFAULT_ARRIVAL_END: new Date('1970-01-02T00:30:00.000Z'),
}

export const inventoryDefaultImage =
  'https://cdn-images.tablelist.com/www-2/tablelist-pro/default-image.png'

export const inventoryDefaultImages = [
  inventoryDefaultImage,
  'https://tablelistpro-assets.imgix.net/www-2/tablelist-pro/default-image.png',
]
